import React from "react";
import { wooProduct } from "./productInterface";
import { useNavigate } from "react-router-dom";
import AddToCart from "../../../src/components/addToCart";
import { Skeleton } from "../../../src/components/ui/skeleton";
import Wishlist from "../../components/Wishlist";
import MyLoader from "../../../src/components/MyLoader";
import useWishlist from "../../../src/hooks/useWishlist";
import { useCookies } from "react-cookie";
import { useQuery } from "react-query";
import { WooCommerce } from "../../../src/lib/api";
import ProductReview from "../../../src/components/productReview";
import { decodeHTML } from "../../../src/lib/utils";
import ProductPreview from "./productPreview";

export default function Products({
  products,
  title,
  search,
}: {
  products: wooProduct[];
  search: string;
  title?: string;
}) {
  const nav = useNavigate();
  const { data: wishlist } = useWishlist();
  const [cookies] = useCookies(["userName", "userToken"]);
  const { data: productsRating } = useQuery(
    ["productsRating"],
    async () => {
      const res = WooCommerce.get("products/reviews")
        .then((response: any) => {
          return response.data;
        })
        .catch((error: any) => {
          console.log(error.response.data);
        });
      return res;
    },
    { enabled: !!cookies.userToken }
  );

  const productsWithRatings = products
    ?.filter((product) =>
      product?.categories?.some(
        (category) =>
          category.id === 486 ||
          category.id === 502 ||
          category.id === 368 ||
          category.id === 505
      )
    )
    .map((product) => {
      if (!productsRating) {
        return { ...product };
      }
      const productReviews = productsRating?.filter(
        (review: any) => review.product_id === product.id
      );
      const averageRating =
        productReviews?.length > 0
          ? productReviews?.reduce(
              (sum: any, review: any) =>
                sum + review.rating,
              0
            ) / productReviews?.length
          : 0;
      return {
        ...product,
        rating: averageRating,
      };
    });
  return (
    <div className="flex-col flex gap-5 w-full">
      {title && (
        <h2 className="font-montserrat font-medium sm:text-2xl text-md text-center lg:text-left">
          {title}
        </h2>
      )}
      <div
        className={
          "flex gap-y-10 overflow-scroll max-h-[700px] justify-start sm:p-20 p-2 items-center gap-x-1 sm:gap-x-10 no-scrollbar flex-wrap w-full"
        }
      >
        {!products ? (
          <div className="w-full h-full">
            <MyLoader />
          </div>
        ) : (
          productsWithRatings
            .filter((p) =>
              p.name
                .toLowerCase()
                .includes(search.toLowerCase())
            )
            .map((product: wooProduct, index) => (
              <div
                className="h-100 rounded-none sm:w-64 w-[49%] font-montserrat justify-between relative flex flex-col gap-2 border-0 shadow-none dark:border-neutral-800 dark:border items-center"
                key={index}
              >
                <div className="absolute top-4 right-4 flex flex-col gap-2">
                  <Wishlist
                    productId={product.id}
                    productName={product.name}
                    wishlist={wishlist}
                  />
                  <ProductPreview product={product} />
                </div>

                <div
                  onClick={() =>
                    nav(
                      `/product/${product?.categories[0]?.id}/${product?.categories[0]?.name}/${product.id}/${product.name}`
                    )
                  }
                  className={
                    "w-full flex justify-center items-center dark:bg-white sm:h-full h-full p-10 cursor-pointer"
                  }
                >
                  <img
                    src={
                      product?.images.length > 0
                        ? product?.images[0].src
                        : "/logo.png"
                    }
                    alt={product.name}
                    className="size-32"
                  />
                </div>

                <div
                  className=" w-full flex flex-col p-0 m-0 flex flex-col gap-2 sm:pl-3 sm:pr-3 pl-1 pr-1 items-start cursor-pointer"
                  onClick={() =>
                    nav(
                      `/product/${product.categories[1].id}/${product.categories[1].name}/${product.id}/${product.slug}`
                    )
                  }
                >
                  {products ? (
                    <p className="line-clamp-2 w-full font-medium text-sm sm:text-md text-center">
                      {decodeHTML(product.name)
                        .charAt(0)
                        .toUpperCase() +
                        String(decodeHTML(product.name))
                          .slice(1)
                          .toLocaleLowerCase()}
                    </p>
                  ) : (
                    <Skeleton className="h-4 w-32" />
                  )}
                </div>
                <div className="sm:pl-3 sm:pr-3 pl-1 pr-1 flex flex-col gap-1 pb-0 flex flex-col gap-5">
                  <p className="truncate sm:w-[200px] w-32 dark:text-neutral-200 text-neutral-900 text-[12px] text-center">
                    {product.description.length > 0
                      ? product?.description.slice(3, -5)
                      : "..."}
                  </p>
                  {cookies.userName && (
                    <div className="flex justify-center items-center gap-2 mt-2">
                      <ProductReview
                        viewOnly
                        rating={product.rating}
                        productId={product.id}
                      />
                    </div>
                  )}
                  <p className="text-md font-bold grow text-center text-neutral-600 dark:text-neutral-100">
                    {product?.price}.00$
                  </p>
                </div>
                <div className="sm:p-2 p-1 w-full">
                  <AddToCart
                    id={String(product.id)}
                    quantity={"1"}
                    name={product.name}
                    categoryId={product.categories[0]?.id}
                    categoryName={
                      product.categories[0]?.name
                    }
                    hasVariations={
                      product?.attributes &&
                      product?.attributes.length > 0
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            ))
        )}
      </div>
    </div>
  );
}
